.list {
  width: 100%;
}

.listItem {
  cursor: pointer;
}
